import {
  TrackEventArg,
  TrackPageOptions,
} from '../../thirdPartyTrackingAgent/types';

interface TrackPageArgs {
  page: string;
  options?: TrackPageOptions;
}

interface GoogleStateParameters {
  [key: string]: unknown;
  hasThePageBeenTracked?: boolean;
  lastTrackedPage?: string;
  hasSetDefaultCustomDimensions?: boolean;
  isStorageInitialized?: boolean;
  eventsQueue?: TrackEventArg[];
  pagesQueue?: TrackPageArgs[];
}

export interface RuntimeGoogleState {
  getGoogleState: () => GoogleStateParameters;
  getEventsQueue: () => TrackEventArg[];
  getPagesQueue: () => TrackPageArgs[];
  setParameters: (params?: Partial<GoogleStateParameters>) => void;
  queueEvent: (event: TrackEventArg) => void;
  queuePage: (page: TrackPageArgs) => void;
  emptyEventsQueue: () => void;
  emptyPagesQueue: () => void;
}

let runtimeGoogleState = null;

export const createRuntimeGoogleState = (): RuntimeGoogleState => {
  if (runtimeGoogleState) {
    return runtimeGoogleState;
  }

  let currentState: GoogleStateParameters = {};

  const setParameters = (configParams: Partial<GoogleStateParameters>) => {
    currentState = { ...currentState, ...configParams };
  };

  const queueEvent = (event: TrackEventArg) => {
    currentState.eventsQueue = currentState.eventsQueue || [];
    currentState.eventsQueue.push(event);
  };

  const queuePage = (page: TrackPageArgs) => {
    currentState.pagesQueue = currentState.pagesQueue || [];
    currentState.pagesQueue.push(page);
  };

  const emptyEventsQueue = () => {
    currentState.eventsQueue = [];
  };
  const emptyPagesQueue = () => {
    currentState.pagesQueue = [];
  };

  const getGoogleState = () => currentState;

  const getEventsQueue = () => currentState.eventsQueue;

  const getPagesQueue = () => currentState.pagesQueue;

  runtimeGoogleState = {
    setParameters,
    getGoogleState,
    getEventsQueue,
    getPagesQueue,
    queueEvent,
    queuePage,
    emptyEventsQueue,
    emptyPagesQueue,
  };

  return runtimeGoogleState;
};

export const resetRuntimeGoogleState = () => {
  runtimeGoogleState = null;
};
